import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TMinorDefaultValues } from '../../type';
import { updateMinor } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';

import Signature from './Signature';
import GuardianInfo from './GuardianInfo';
import InspectionItems from './InspectionItems';

const MinorConsent = (props: SurveyDialogProps<TMinorDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TMinorDefaultValues) => {
    const {
      guardian_name1,
      guardian_birth,
      guardian_contact,
      guardian_address,
      guardian_relation,

      procedure_date,
      procedure_content,

      date,
      patient_name,
      patient_sig,
      guardian_name2,
      guardian_sig,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      minor_consent: {
        guardian_name1,
        guardian_birth,
        guardian_contact,
        guardian_address,
        guardian_relation,

        procedure_date,
        procedure_content,

        date,
        patient_name,
        patient_sig,
        guardian_name2,
        guardian_sig,
      },
    };

    updateMinor(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => {
        onFail('저장에 실패하였습니다', e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        미성년자 시술동의서
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <GuardianInfo {...formProps} />
        <InspectionItems {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default MinorConsent;
